export const isServer = typeof window === 'undefined';
export const isWeb = !isServer;
export const isNative = false;
export const isIOS = false;
export const isAndroid = false;

export const isAdmin = true;
export const isMember = false;
export const isPublic = false;